package com.steamstreet.dates

import kotlinx.serialization.KSerializer
import kotlinx.serialization.descriptors.PrimitiveKind
import kotlinx.serialization.descriptors.PrimitiveSerialDescriptor
import kotlinx.serialization.descriptors.SerialDescriptor
import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.encoding.Encoder
import kotlin.time.Instant

/**
 * Serializes an [Instant] as an ISO-8601 string. This replaces the kotlinx-datetime
 * `InstantIso8601Serializer`, which only handles the deprecated `kotlinx.datetime.Instant`.
 * The wire format is identical, so the GraphQL representation is unchanged.
 */
public object InstantSerializer : KSerializer<Instant> {
    // The serial name must not collide with the built-in `kotlin.time.Instant`
    // serializer that kotlinx-serialization already registers.
    override val descriptor: SerialDescriptor =
        PrimitiveSerialDescriptor("com.steamstreet.dates.InstantSerializer", PrimitiveKind.STRING)

    override fun deserialize(decoder: Decoder): Instant {
        return Instant.parse(decoder.decodeString())
    }

    override fun serialize(encoder: Encoder, value: Instant) {
        encoder.encodeString(value.toString())
    }
}
